import React from 'react';

export const CountStep = (props: { title: string; current: number; total?: number }) => {
    return (
        <section
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'flex-start',
            }}
        >
            <div className="title-detail">{props.title}</div>
            <div className="title-detail">{`${props.current}/${props?.total ?? 5}`}</div>
        </section>
    );
};
